import { render, staticRenderFns } from "./LinkTab.vue?vue&type=template&id=0b1059ef&"
import script from "./LinkTab.vue?vue&type=script&lang=js&"
export * from "./LinkTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports